/**
 * Portfolio interactions are initialized globally by PublicListController.
 * Keep route actions registered so the app dispatcher does not report a
 * missing controller entry on the public list and detail pages.
 */
export const PortfolioController = {
    index(): void {},
    show(): void {},
};
